import React from 'react';
import { toFlag } from 'pano-utils';
import type { BooleanFlag } from '@types';
import Textarea from '@components/Textarea';
import FeatureToggle from '@components/FeatureToggle';
import Button from '@components/Button';
import { Collapse } from '@components/Collapse';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import { $playerWidgetsApi } from '@stores/playerWidgets';

type Props = {
  title?: string;
  showTitle?: BooleanFlag;
  onTitleChange?: (val: string) => void;
  onToggleChange: (val: BooleanFlag) => void;
};

export function TitleSetting({
  title,
  showTitle,
  onTitleChange,
  onToggleChange,
}: Props) {
  const handlers = useTextareaHandelrs('trimRight', (val) => {
    onTitleChange?.(val);
  });

  return (
    <Collapse title="标题设置">
      {!!onTitleChange && (
        <Textarea
          scheme="dark"
          className="mb-20 h-115"
          placeholder="请输入标记标题"
          maxLength={500}
          value={title}
          {...handlers}
        />
      )}
      <FeatureToggle
        title="显示标题"
        className="mb-20"
        isOn={!!showTitle}
        onToggle={(isOn) => {
          onToggleChange(toFlag(isOn));
        }}
      />
      {!!showTitle && (
        <Button
          className="mt-20 w-full"
          onClick={() => $playerWidgetsApi.add('title')}
        >
          标题高级设置
        </Button>
      )}
    </Collapse>
  );
}
